var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('highcharts',{ref:"highchart",attrs:{"options":_vm.chartOptions}}),_c('ChartIndicator',{attrs:{"label":_vm.displayScore,"xPosition":_vm.indicatorXPosition}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }